/* unplugin-vue-components disabled */import { render } from "./insCommission.vue?vue&type=template&id=73914020&scoped=true"
import script from "./insCommission.vue?vue&type=script&lang=js"
export * from "./insCommission.vue?vue&type=script&lang=js"

import "./insCommission.vue?vue&type=style&index=0&id=73914020&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73914020"]])

export default __exports__